export const DEPARTMENTS = ["Tilburg", "Eindhoven", "Breda"];

export const CATEGORY_HOURS = "hours";
export const CATEGORY_LEAVE_REQUESTS = "leave_requests";
export const CATEGORY_SICKNESS = "sickness";
export const CATEGORY_DOCUMENTS = "documents";
export const CATEGORY_OTHER = "other";

export const CHAT_CATEGORIES = [
    CATEGORY_HOURS,
    CATEGORY_LEAVE_REQUESTS,
    CATEGORY_SICKNESS,
    CATEGORY_DOCUMENTS,
    CATEGORY_OTHER
];

export const TYPE_HOURS_PENDING = 'hoursPending';
export const TYPE_HOURS_APPROVED = 'hoursApproved';
export const TYPE_HOURS_REJECTED = 'hoursRejected';
export const TYPE_LEAVE_CREATED = 'leaveRequestCreated';
export const TYPE_LEAVE_UPDATED = 'leaveRequestModified';
export const TYPE_SICKLEAVE_CREATED = 'sickLeaveCreated';
export const TYPE_SICKLEAVE_UPDATED = 'sickLeaveUpdated';
export const TYPE_CHAT_CREATED = 'chatCreated';
export const TYPE_CHAT_REALLOCATED = 'chatReallocated';
export const TYPE_DOCUMENT_CREATED = 'document';
export const TYPE_REALLOCATE_REQUEST = 'reallocateRequest';

export const CHAT_NOTIFICATION_TYPES = [
    TYPE_CHAT_CREATED,
    TYPE_CHAT_REALLOCATED,
    TYPE_REALLOCATE_REQUEST
];

export const PORTAL_NOTIFICATION_TYPES = [
    TYPE_HOURS_PENDING,
    TYPE_HOURS_APPROVED,
    TYPE_HOURS_REJECTED,
    TYPE_LEAVE_CREATED,
    TYPE_LEAVE_UPDATED,
    TYPE_SICKLEAVE_CREATED,
    TYPE_CHAT_CREATED,
    TYPE_CHAT_REALLOCATED,
    TYPE_SICKLEAVE_UPDATED,
    TYPE_DOCUMENT_CREATED,
    TYPE_REALLOCATE_REQUEST
]

export const PORTAL_NOTIFICATION_TYPES_LABEL = {
    [TYPE_HOURS_PENDING]: 'Hours Pending',
    [TYPE_HOURS_APPROVED]: 'Hours Approved',
    [TYPE_HOURS_REJECTED]: 'Hours Rejected',
    [TYPE_LEAVE_CREATED]: 'Leave Request Created',
    [TYPE_LEAVE_UPDATED]: 'Leave Request Updated',
    [TYPE_SICKLEAVE_CREATED]: 'Sick Leave Created',
    [TYPE_CHAT_CREATED]: 'Chat Created',
    [TYPE_CHAT_REALLOCATED]: 'Chat Reallocated',
    [TYPE_DOCUMENT_CREATED]: 'Document Created',
    [TYPE_SICKLEAVE_UPDATED]: 'Sick Leave finished',
    [TYPE_REALLOCATE_REQUEST]: 'Reallocate Request Received',
}